import styled from 'styled-components';

export default styled.div`
  .display-column-between {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .params-icon-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fafafa;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
